import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../index.css'
import axios from 'axios'
import VCalendar from 'v-calendar';

//import 'leaflet/dist/leaflet.css'; run serve


const app = createApp(App)
app.use(store)
app.use(router)
app.use(VCalendar, {})
app.config.globalProperties.axios=axios
//app.use(axios)
app.mount('#app')

//createApp(App).use(store).use(router).mount('#app')
